module.exports = __webpack_public_path__ + "img/bg-spaceman.65f309a5.jpg";